import { ButtonType } from './types';

export const getEmail = () => JSON.parse(localStorage.getItem('profile') || '{}').email;

export const getUrl = (type: ButtonType, href: string) => {
  const TYPE_TO_URL: Record<ButtonType, string> = {
    dashboard: `${import.meta.env.VITE_API_URL}/admin/candidates/partner-change?email=${getEmail()}&url=${href}`,
    report: href,
  };

  return TYPE_TO_URL?.[type] || null;
};
